module.exports = __webpack_public_path__ + "img/b0611f1.jpg";